import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { AnalyticsApi } from 'src/services/analyticsApi'
import { InboxOverviewResponse } from 'src/services/__generated__/api'

interface UseGetInboxOverviewParams {
  enabled?: boolean
  fromDate?: string
  groupBy: 'platforms' | 'operators'
  operatorIds?: string
  pageId: string
  platforms?: string
  toDate?: string
}

export const useGetInboxOverviewQuery = (params: UseGetInboxOverviewParams) => {
  return useQuery<InboxOverviewResponse | null>({
    enabled: !!params.pageId && params.enabled !== false,
    placeholderData: keepPreviousData,
    queryFn: async () => {
      const { data } = await AnalyticsApi.v1Private.inboxAnalysisOverviewList(
        {
          fromDate: params.fromDate,
          groupBy: params.groupBy,
          operatorIds: params.operatorIds,
          pageId: params.pageId,
          platforms: params.platforms,
          toDate: params.toDate,
        },
        { format: 'json' }
      )
      return data as InboxOverviewResponse
    },
    queryKey: [
      QueryKey.GET_INBOX_OVERVIEW,
      params.pageId,
      params.groupBy,
      params.platforms,
      params.operatorIds,
      params.fromDate,
      params.toDate,
    ],
  })
}
